/**
 * Converts time into normalized time format (HH:MM)
 * For hours, it adds a 0 in front if needed, and for minutes it tails the end with 0
 * Examples: 1 -> 01:00, 10 -> 10:00, 15:1 -> 15:10
 * To get a consistent format of HH:MM
 *
 * @param time - in any incomplete form of HH:MM
 * @returns Normalized time in format HH:MM
 */
export const normalizeTime = (time: string): string => {
  if (time === '') {
    return time;
  }
  const [hours = '', minutes = ''] = time.split(':');
  const normalizedHours = `00${hours}`.slice(-2);
  const normalizedMinutes = `${minutes}00`.slice(0, 2);
  return `${normalizedHours}:${normalizedMinutes}`;
};
